import { RestUrl } from "../../common/cyan.types";

export class EcoaAuthenticateCodeUrl {
  public static getAliveAuthenticateCodeSms: RestUrl = ["GET", "/ecoa/authenticate/alive"];
  public static verifyEcoaAuthenticateCode: RestUrl = ["POST", "/ecoa/authenticate/verify"];
}
